import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface ProjectCardSkeletonProps {
  count?: number;
  className?: string;
}

const ProjectCardSkeleton = ({
  count = 1,
  className,
}: ProjectCardSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            styles.projectCardSkeleton,
            "flex gap-3",
            className,
          )}
        >
          <div className={styles.imgSkeleton}>
            <SkeletonLoader className={styles.skeletonImage} />
          </div>

          <div className={styles.contentSkeleton}>
            <div className={styles.headerSkeleton}>
              <SkeletonLoader className={styles.titleSkeleton} />
              <div className={styles.badgeSkeleton}>
                <SkeletonLoader className={styles.badge} />
              </div>
            </div>

            <div className={styles.infoSkeleton}>
              <SkeletonLoader className={styles.infoText} />
            </div>

            <div className={styles.statusBarSkeleton}>
              <SkeletonLoader className={styles.statusBar} />
            </div>

            <div className={styles.actionSkeleton}>
              <SkeletonLoader className={styles.buttonSkeleton} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProjectCardSkeleton;
